module.exports = __webpack_public_path__ + "static/media/iv_share_contacts.d38433fc.svg";